import React from "react";
import styled from "styled-components";
import Modal from 'react-modal';
import { useTranslation } from "react-i18next";

import useLoadingStore from "../../store/useLoadingStore";
import useModalStore from "../../store/useModalStore";
import FormButtonSecondary from "../form/FormButtonSecondary";
import FormButtonPrimary from "../form/FormButtonPrimary";
import FormButtonDanger from "../form/FormButtonDanger";
import LoadingIcon from "../core/LoadingIcon";
import Space from "../core/Space";
import ShadowBox from "../core/ShadowBox";
import Flex from "../core/Flex";
import FormRemark from "../form/FormRemark";

const ModalInfo = ({ children }) => {
    const { t } = useTranslation();
    const {
        isModalInfoOpen,
        closeModalInfo,
        modalInfoTitle,
        modalInfoText,
        modalInfoContent,
        modalInfoStyle,
        modalConfirmShowSuccessIcon,
        modalConfirmShowFailIcon,
        modalConfirmShowConfirmBtn,
        modalInfoPrimaryButtonStyleChangeToDanger,
        modalInfoButtonText,
        modalInfoID,
    } = useModalStore();

    return (
        <Modal
            // For open timeout, please find in index.css
            id={modalInfoID}
            closeTimeoutMS={250}
            isOpen={isModalInfoOpen}
            onRequestClose={closeModalInfo}
            style={{
                content: { ...customStyles.content, ...modalInfoStyle.content },
                overlay: { ...customStyles.overlay, ...modalInfoStyle.overlay },
            }}
            ariaHideApp={false}
        >
            {
                modalInfoTitle && <ModalTitle style={modalInfoText ? {} : { textAlign: "center" }}>{modalInfoTitle}</ModalTitle>
            }

            <Space height={16} />

            {
                modalConfirmShowSuccessIcon &&
                <>
                    <IconStatus src={`${process.env.PUBLIC_URL}/images/circle-success.png`} alt="success" />
                    <Space height={8} />
                </>
            }

            {
                modalConfirmShowFailIcon &&
                <>
                    <IconStatus src={`${process.env.PUBLIC_URL}/images/circle-success.png`} alt="fail" />
                    <Space height={8} />
                </>
            }

            {
                modalInfoText &&
                <>
                    <ModalText>{modalInfoText}</ModalText>
                    <Space height={48} />
                </>
            }

            {modalInfoContent}

            {
                modalConfirmShowConfirmBtn && (
                    <ModalButtonRow>
                        {
                            modalInfoPrimaryButtonStyleChangeToDanger ?
                                <ButtonDanger size={"small"} onClick={() => {
                                    closeModalInfo();
                                }}>{modalInfoButtonText ? modalInfoButtonText : t("confirm")}</ButtonDanger>
                                :
                                <FormButtonPrimary size={"small"} onClick={() => {
                                    closeModalInfo();
                                }}>{modalInfoButtonText ? modalInfoButtonText : t("confirm")}</FormButtonPrimary>
                        }
                    </ModalButtonRow>
                )
            }
        </Modal>
    );
};

const customStyles = {
    overlay: {
        background: 'rgba(0, 0, 0, 0.3)',
        zIndex: 1500,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: "95vw",
        maxHeight: '95vh',
        width: 480,
        padding: 32,
        borderRadius: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
};

const ModalTitle = styled.div`
  font-size: 20px;
  line-height: 30px;
  font-weight: bold;
  color: var(--aia-bx-dark-blue);
`;

const ModalText = styled.div`
font-size: 16px;
line-height: 26px;
  color: var(--aia-bx-black);
`;

const ModalButtonRow = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
`;

const IconStatus = styled.img`
  width: 86px;
  height: 86px;
`;

const ButtonDanger = styled.button`
  flex-shrink: 0;
  padding: 11px 60px;
  background-color: var(--aia-bx-red-1);
  color: var(--aia-bx-white);
  border: 1px solid var(--aia-bx-red-1);
  border-radius: 100px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  visibility: visible;

  ${props => props.$disabled ? `
      cursor: not-allowed;
      background-color: var(--aia-bx-gray-5);
      border-color: var(--aia-bx-gray-5);
      color: var(--aia-bx-gray-4);
    `
        :
        `
    &:hover {
      background-color: var(--aia-bx-red-4);
    }
  `};
`;

export default ModalInfo;